import React from 'react';
import {
  ButtonBase, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, makeStyles,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  title: {
    textAlign: 'center',
    fontSize: 18,
  },
  content: {
  },
  contentText: {
    color: 'black',
    fontSize: 16,
  },
  hr: {
    borderTopColor: '#979797',
    marginBottom: 0,
  },
  button: {
    color: 'black',
    fontSize: 16,
    fontWeight: 'bold',
    width: '100%',
    '&:hover': {
      opacity: 0.5,
    },
  },
  footer: {
    paddingBottom: theme.spacing(2),
  },
}));

export default ({
  data,
  isOpen,
  onCancelButtonClick,
  onOkButtonClick,
}) => {
  const { title, isPriority } = data || {};
  const classes = useStyles();

  return (
    <Dialog
      open={isOpen}
      keepMounted
      onClose={onCancelButtonClick}
    >
      <DialogTitle className={classes.title}>
        {isPriority ? '解除優先使用' : '設為優先使用'}
      </DialogTitle>
      <DialogContent>
        <DialogContentText className={classes.contentText}>
          您要將
          {' "'}
          {title}
          {'" '}
          {isPriority ? '解除' : '設為'}
          優先使用嗎？
        </DialogContentText>
        {!isPriority && (
          <DialogContentText className={classes.contentText}>
            下次消費時會優先使用此優惠券
          </DialogContentText>
        )}
        <hr className={classes.hr} />
      </DialogContent>
      <DialogActions className={classes.footer}>
        <ButtonBase
          className={classes.button}
          onClick={onCancelButtonClick}
        >
          否
        </ButtonBase>
        <ButtonBase
          className={classes.button}
          onClick={onOkButtonClick}
        >
          是
        </ButtonBase>
      </DialogActions>
    </Dialog>
  );
};
